import { Error, Sensors } from "@mui/icons-material";
import { Grid, LinearProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  prepareConfigJson,
  prepareNetTestJson,
  prepareParamsJson,
  prepareSensorJson,
} from "../costant";
import { commit, init, uploadFiles } from "../../endpoints/configuratorApi";

type RobbyConnectionProps = {
  values: any;
  handleNext: () => void;
};

const RobbyConnection: React.FC<RobbyConnectionProps> = ({
  values,
  handleNext,
}) => {
  const { t } = useTranslation();

  const [failed, setFailed] = useState<boolean>(false);

  useEffect(() => {
    if (values.deviceId) {
      const netFile = {
        file: new File(
          [
            new TextEncoder().encode(JSON.stringify(values.configuration)),
          ] as BlobPart[],
          "net.json"
        ),
      };
      const paramsFile = {
        file: new File(
          [
            new TextEncoder().encode(
              JSON.stringify(prepareParamsJson(values.robby))
            ),
          ] as BlobPart[],
          "params.json"
        ),
      };
      const sensorsFile = {
        file: new File(
          [
            new TextEncoder().encode(JSON.stringify(prepareSensorJson)),
          ] as BlobPart[],
          "sensors.json"
        ),
      };
      const configFile = {
        file: new File(
          [
            new TextEncoder().encode(JSON.stringify(prepareConfigJson)),
          ] as BlobPart[],
          "config.json"
        ),
      };
      const netTestFile = {
        file: new File(
          [
            new TextEncoder().encode(JSON.stringify(prepareNetTestJson)),
          ] as BlobPart[],
          "net_test.json"
        ),
      };
      init(values.deviceId)
        .then(
          async () =>
            await uploadFiles(values.deviceId, [
              netFile,
              paramsFile,
              sensorsFile,
              configFile,
              netTestFile,
            ]).then(async (res: any) => {
              if (res && res.files) {
                await commit(values.deviceId, true).then((r: any) => {
                  if (r && r.version) {
                    handleNext();
                  } else {
                    setFailed(true);
                  }
                });
              } else {
                setFailed(true);
              }
            })
        )
        .catch((err: any) => {
          console.log("ERROR", err);
          setFailed(true);
        });
    } else {
      setFailed(true);
    }
  }, [values]);

  return (
    <Grid
      container
      spacing={2}
      direction="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
    >
      <Grid item>
        <Sensors style={{ fontSize: "64px" }} />
      </Grid>
      <Grid item>
        <Typography variant="h5">{t("deviceConfiguration")}</Typography>
      </Grid>
      <Grid item>
        <Typography>
          {failed
            ? t("deviceConfigurationFailed")
            : t("deviceConfigurationDescriptionForUser")}
        </Typography>
      </Grid>
      {failed ? (
        <Grid item>
          <Error style={{ fontSize: "128px", color: "red" }} />
        </Grid>
      ) : (
        <Grid
          container
          item
          spacing={4}
          alignItems="center"
          justifyContent="center"
          textAlign="left"
        >
          <Grid item xs={12} md={8} xl={6}>
            <LinearProgress />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default RobbyConnection;
